export const getters = {
  saleRateIndexingRuleList: ({ saleRateIndexingRuleList }) => saleRateIndexingRuleList,
};
